"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AllergyLineResultSchema () {
        return _prescriptionallergycheck.AllergyLineResultSchema;
    },
    get CLINIC_PROFILE_MISSING () {
        return _prescriptionerrors.CLINIC_PROFILE_MISSING;
    },
    get ENCOUNTER_PRESCRIPTION_GENERIC_NAMES_MAX () {
        return _encounterprescriptions.ENCOUNTER_PRESCRIPTION_GENERIC_NAMES_MAX;
    },
    get EncounterPrescriptionListItemSchema () {
        return _encounterprescriptions.EncounterPrescriptionListItemSchema;
    },
    get EncounterPrescriptionListResponseSchema () {
        return _encounterprescriptions.EncounterPrescriptionListResponseSchema;
    },
    get MEDICATION_DANGEROUS_DRUG_UNSUPPORTED () {
        return _prescriptionerrors.MEDICATION_DANGEROUS_DRUG_UNSUPPORTED;
    },
    get PRESCRIBER_CREDENTIALS_MISSING () {
        return _prescriptionerrors.PRESCRIBER_CREDENTIALS_MISSING;
    },
    get PRESCRIBER_LICENSE_EXPIRED () {
        return _prescriptionerrors.PRESCRIBER_LICENSE_EXPIRED;
    },
    get PRESCRIPTION_ACK_REQUIRED () {
        return _prescriptionerrors.PRESCRIPTION_ACK_REQUIRED;
    },
    get PRESCRIPTION_ALLERGIES_CHANGED () {
        return _prescriptionerrors.PRESCRIPTION_ALLERGIES_CHANGED;
    },
    get PRESCRIPTION_ALLERGY_CONFLICT () {
        return _prescriptionerrors.PRESCRIPTION_ALLERGY_CONFLICT;
    },
    get PRESCRIPTION_BRANCH_REQUIRED () {
        return _prescriptionerrors.PRESCRIPTION_BRANCH_REQUIRED;
    },
    get PRESCRIPTION_EMPTY () {
        return _prescriptionerrors.PRESCRIPTION_EMPTY;
    },
    get PRESCRIPTION_ENCOUNTER_NOT_ELIGIBLE () {
        return _prescriptionerrors.PRESCRIPTION_ENCOUNTER_NOT_ELIGIBLE;
    },
    get PRESCRIPTION_LIMITS () {
        return _prescriptionstatus.PRESCRIPTION_LIMITS;
    },
    get PRESCRIPTION_LOCKED () {
        return _prescriptionerrors.PRESCRIPTION_LOCKED;
    },
    get PRESCRIPTION_MEDICATION_UNKNOWN () {
        return _prescriptionerrors.PRESCRIPTION_MEDICATION_UNKNOWN;
    },
    get PRESCRIPTION_NOT_PRESCRIBER () {
        return _prescriptionerrors.PRESCRIPTION_NOT_PRESCRIBER;
    },
    get PRESCRIPTION_VERSION_CONFLICT () {
        return _prescriptionerrors.PRESCRIPTION_VERSION_CONFLICT;
    },
    get PRESCRIPTION_VOID_REASONS () {
        return _prescriptionstatus.PRESCRIPTION_VOID_REASONS;
    },
    get PRESCRIPTION_VOID_REASON_LABELS () {
        return _prescriptionstatus.PRESCRIPTION_VOID_REASON_LABELS;
    },
    get PrescriberCheckSchema () {
        return _prescriptiondetail.PrescriberCheckSchema;
    },
    get PrescriptionAllergyAcknowledgementsSchema () {
        return _prescriptionallergycheck.PrescriptionAllergyAcknowledgementsSchema;
    },
    get PrescriptionAllergyCheckSchema () {
        return _prescriptionallergycheck.PrescriptionAllergyCheckSchema;
    },
    get PrescriptionAllergyLineSchema () {
        return _prescriptionallergycheck.PrescriptionAllergyLineSchema;
    },
    get PrescriptionClinicOptionSchema () {
        return _prescriptiondetail.PrescriptionClinicOptionSchema;
    },
    get PrescriptionCreateRequestSchema () {
        return _prescriptionrequests.PrescriptionCreateRequestSchema;
    },
    get PrescriptionCreateResponseSchema () {
        return _prescriptionrequests.PrescriptionCreateResponseSchema;
    },
    get PrescriptionDetailSchema () {
        return _prescriptiondetail.PrescriptionDetailSchema;
    },
    get PrescriptionDiscardResponseSchema () {
        return _prescriptionrequests.PrescriptionDiscardResponseSchema;
    },
    get PrescriptionGamotReferenceRequestSchema () {
        return _prescriptionrequests.PrescriptionGamotReferenceRequestSchema;
    },
    get PrescriptionIssueRequestSchema () {
        return _prescriptionrequests.PrescriptionIssueRequestSchema;
    },
    get PrescriptionIssuedAllergyCheckSchema () {
        return _prescriptionallergycheck.PrescriptionIssuedAllergyCheckSchema;
    },
    get PrescriptionItemInputSchema () {
        return _prescriptionitem.PrescriptionItemInputSchema;
    },
    get PrescriptionItemSchema () {
        return _prescriptionitem.PrescriptionItemSchema;
    },
    get PrescriptionPatientSnapshotSchema () {
        return _prescriptiondetail.PrescriptionPatientSnapshotSchema;
    },
    get PrescriptionSaveRequestSchema () {
        return _prescriptionrequests.PrescriptionSaveRequestSchema;
    },
    get PrescriptionStatusSchema () {
        return _prescriptionstatus.PrescriptionStatusSchema;
    },
    get PrescriptionVoidReasonSchema () {
        return _prescriptionstatus.PrescriptionVoidReasonSchema;
    },
    get PrescriptionVoidRequestSchema () {
        return _prescriptionrequests.PrescriptionVoidRequestSchema;
    },
    get QUANTITY_SUGGESTED_FORMS () {
        return _prescriptionitem.QUANTITY_SUGGESTED_FORMS;
    },
    get suggestQuantity () {
        return _prescriptionitem.suggestQuantity;
    }
});
const _prescriptionstatus = require("./prescription-status");
const _prescriptionitem = require("./prescription-item");
const _prescriptionallergycheck = require("./prescription-allergy-check");
const _prescriptiondetail = require("./prescription-detail");
const _prescriptionrequests = require("./prescription-requests");
const _encounterprescriptions = require("./encounter-prescriptions");
const _prescriptionerrors = require("./prescription-errors");
